"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.binary2ocet = void 0;
var binary2ocet = function (data) {
    var buf = new ArrayBuffer(data.length); // convert s to arrayBuffer
    var view = new Uint8Array(buf); // create uint8array as viewer
    for (var i = 0; i < data.length; i++)
        view[i] = data.charCodeAt(i) & 0xff; // convert to octet
    return buf;
};
exports.binary2ocet = binary2ocet;
